module.exports = __webpack_public_path__ + "static/4-0f437cee5c36951e87acea71292093c8.jpg";